import {
  UpdateEvaluationWithAttachmentsParams,
  editEvaluationWithAttachments,
} from "api/api";
import { useMutation } from "react-query";
import { MUTATION_KEYS } from "store/constants";

import { handleAxiosError } from "store/util";

const updateEvaluation = async ({
  locationId,
  reportId,
  recommendationId,
  evaluationId,
  body,
}: UpdateEvaluationWithAttachmentsParams) => {
  return await editEvaluationWithAttachments(
    locationId,
    reportId,
    recommendationId,
    evaluationId,
    body
  );
};

export function useUpdateEvaluation() {
  return useMutation(updateEvaluation, {
    mutationKey: MUTATION_KEYS.updateEvaluation,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
